import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import facultyData from "../UG/facultyData/basicScienceFacultyData";

export const programme = {
  id: "mathematics",
  name: "Mathematics Research Centre",
  short: "Mathematics Research Centre",
  programmeType: "research",
  programmeLabel: "Research Centre",
  duration: "Ph.D. / M.Sc. (Engg.) by Research",
  established: "As per VTU recognition",
  hodId: "f-meenal-m-kaliwal",
  facultyData,
  facultyDeptId: "bsh",
  hideFacultySection: true,
  hideSharedClubs: true,

  description:
    "The Mathematics Research Centre supports research in graph theory, applied mathematics, discrete mathematics, optimisation, and mathematical modelling. The centre encourages doctoral research, analytical thinking, publication activity, and interdisciplinary mathematical applications.",

  image: "/Campus/maths.jpg",

  labs: [
    "Mathematics Learning Centre",
    "Research Workspaces",
    "Computational Tools",
    "Seminar Facilities",
  ],

  dashboard: [
    ["Recognition", "VTU"],
    ["Research Areas", "04"],
    ["Research Supervisors", "02"],
    ["Research Scholars", "05"],
  ],

  quickFacts: [
    ["Established", "As per VTU recognition"],
    ["Programme", "Ph.D. / M.Sc. (Engg.) by Research"],
    ["Research Supervisors", "02"],
    ["Research Scholars", "05"],
    ["Research Areas", "Graph Theory, Applied Mathematics, Discrete Mathematics, Optimisation"],
    ["Affiliation", "VTU, Belagavi"],
  ],

  academicOverview: [
    {
      title: "Research Centre Overview",
      text:
        "The Mathematics Research Centre provides faculty-led research guidance in graph theory, discrete mathematics, applied mathematics, optimisation, and mathematical modelling.",
    },
    {
      title: "Research Facilities",
      text:
        "The centre supports research through mathematical learning spaces, computational tools, seminar facilities, literature review support, and scholarly discussion.",
    },
    {
      title: "Research Culture",
      text:
        "The centre promotes publications, seminars, conference participation, academic mentoring, and research activity that connects mathematical theory with engineering applications.",
    },
  ],

  curriculumSupport: [
    "Ph.D. and M.Sc. (Engineering) by Research guidance",
    "Graph theory and discrete mathematics research support",
    "Mathematical modelling and optimisation guidance",
    "Computational mathematics support",
    "Publication and conference presentation support",
    "Research methodology and documentation support",
  ],

  researchAreas: [
    "Graph Theory",
    "Applied Mathematics",
    "Discrete Mathematics",
    "Optimisation",
  ],

  // infrastructure: [
  //   ["Mathematics Learning Centre", "Available"],
  //   ["Research Workspaces", "Available"],
  //   ["Computational Tools", "Available"],
  //   ["Seminar Facilities", "Available"],
  //   ["Research Support", "Mathematical modelling, analysis, and documentation"],
  // ],

  achievements: [
    "Supports research publications in mathematics.",
    "Provides doctoral research guidance and academic mentoring.",
    "Promotes seminars, conference participation, and mathematical research activity.",
    "Research focus includes graph theory and discrete mathematics.",
  ],

  supervisors: [
    ["Dr. Meenal M. Kaliwal", "Assistant Professor", "f-meenal-m-kaliwal"],
    ["Satish Hande","Assistant Professor","f-satish-hande"]
  ],

  researchScholars: [
    ["Mrs. Sarojini Naik", "Research Scholar", null, "/FacultyCImages/Sarojini Naik.png"],
    ["Smt. Geeta Kameri", "Research Scholar", null, "/FacultyCImages/Geeta Kameri.png"],
    ["Smt. Mahananda Bhopale", "Research Scholar", null, "/FacultyCImages/Mahananda Bhopale.png"],
    ["Mr. Virupaksha Patil", "Research Scholar", null, "/FacultyCImages/Virupaksha Patil.png"],
    ["Smt. Renuka Janagond", "Research Scholar", null, "/FacultyCImages/Renuka Janagond.png"],
  ],
};

const MathematicsResearchCentre = () => <ProgrammeDetail programme={programme} />;

export default MathematicsResearchCentre;
